import { apiClient } from "./StripeBaseServices";

export default {
  createPaymentIntent(payload) {
    return apiClient.appClient.post("/create-payment-intent", payload);
  },
  flutterwaveFunding(payload) {
    return apiClient.appClient.post("/flutterwave-funding", payload);
  },
  flutterwaveVerify(payload) {
    return apiClient.appClient.post("/flutterwave-verify", payload);
  }
};
